import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DatasourceService} from '../../services/datasource/datasource.service';
import {DropDownFieldOption} from '../../interfaces/DropDownFieldOption';

@Component({
  selector: 'app-dialog-field',
  templateUrl: './dialog-field.component.html',
  styleUrls: ['./dialog-field.component.scss']
})
export class DialogFieldComponent implements OnInit {

  listDataSources: string[];
  private identifier = 0;

  @Input() dataSource: string;
  @Input() fields: DropDownFieldOption[] = [];
  @Output() onDataSourceChanged = new EventEmitter();
  @Output() onFieldOptionChanged = new EventEmitter();

  constructor(
      private datasourceService: DatasourceService) { }

  ngOnInit() {
    // Get list of datasources
      this.datasourceService.getList()
          .then((response) => {
              this.listDataSources = Object.keys(response).map(function(k) { return response[k] });
              this.listDataSources.push('Manual');
              console.log(this.listDataSources);
            });
  }

  addInput() {
    this.fields.push({name: '', id: this.identifier});
    this.identifier++;
  }

  removeInput(option: DropDownFieldOption) {
    const index = this.fields.indexOf(option);
    this.fields.splice(index, 1);
  }

  onValueChanged() {
      this.onDataSourceChanged.emit(this.dataSource);
  }

  onFieldChanged() {
      this.onFieldOptionChanged.emit(this.fields);
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/components/dialog-field/dialog-field.component.ts